<template lang="pug">
div(style="margin-top: -24px;margin-left: 0px;margin-right: 0px;")
  #Productos
    HelloWorld
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        div(style="margin-top: 20px;")
            v-layout(align-center='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12 sm12)
                  v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                    a(@click='sinEst()')
                      v-card(style='width:300px;height:120px;border-radius:10px;padding: 10px;').elevation-3
                          span(style='display:flex;justify-content:center;font-size:22px') Ultimo Pedido
                          span(v-if='nro' style='display:flex;justify-content:center;font-size: 40px;font-weight: 500;') {{nro}}
                          span(v-else style='display:flex;justify-content:center;font-size: 40px;font-weight: 500;') ...
              v-flex(xs12 sm12 style='margin-top:20px;')
                  v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                    a(@click='sinEst()')
                      v-card(style='width:300px;height:120px;border-radius:10px;padding: 10px;').elevation-3
                          span(style='display:flex;justify-content:center;font-size:22px') Ultima Cotización
                          span(v-if='nro' style='display:flex;justify-content:center;font-size: 40px;font-weight: 500;') {{nroC}}
                          span(v-else style='display:flex;justify-content:center;font-size: 40px;font-weight: 500;') ...
</template>

<script>
import HelloWorld from "../components/HelloWorld";
import Api from "@/services/methods";
export default {
  components: {
    HelloWorld
  },
  data: () => ({
    nro: null,
    nroC: null,
  }),
  created() {
    this.initialize();
    this.cicle();
  },
  methods: {
    initialize() {
      Api.get("pedidosCom/ultimo").then(res => {
        if (res.data && res.data[0]) this.nro = res.data[0].doc_num.trim()
      });
      Api.get("cotizacionCom/ultimo").then(res => {
        if (res.data && res.data[0]) this.nroC = res.data[0].doc_num.trim()
      });
    },
    cicle() {
      setTimeout(function() {
        this.initialize();
        this.cicle();
      }.bind(this), 60000);
    }
  }
};
</script>
